// Single source of truth for default mail categories used by the on-device
// categorization on both web (embedding similarity) and mobile (NLI / Llama).
// User-confirmed tags are merged in at runtime — these are just the seed labels.
export const DEFAULT_CATEGORIES = [
  'Newsletter',
  'Werbung',
  'Bestellung',
  'Rechnung',
  'Spam',
  'Termin',
  'Reise',
  'Finanzen',
  'Sendung',
  'Konto',
  'Arbeit',
  'Privat',
] as const;

export type DefaultCategory = (typeof DEFAULT_CATEGORIES)[number];

// Richer descriptions used by the web embedding-similarity classifier — the
// model matches these against the email text, but only the key (display name)
// becomes the tag. NLI/Llama paths on mobile use the bare category names.
export const CATEGORY_DESCRIPTIONS: Record<string, string> = {
  Newsletter: 'Newsletter Ankündigung Neuigkeiten Rundschreiben Abonnement',
  Werbung: 'Werbung Angebot Rabatt Gutschein Aktion Promo Sale Prozent sparen',
  Bestellung: 'Bestellbestätigung Auftragsbestätigung Kauf abgeschlossen Artikel versandt',
  Rechnung: 'Rechnung Zahlung Invoice Quittung Beleg Betrag fällig',
  Spam: 'Spam unerwünscht Betrug Phishing verdächtig',
  Termin: 'Termin Kalender Meeting Verabredung Einladung',
  Reise: 'Reise Flug Hotel Urlaub Buchung Ticket Bahn',
  Finanzen: 'Finanzen Bank Überweisung Kontoauszug Steuer',
  Sendung: 'Sendung Paket Lieferung Tracking Versand DHL Hermes',
  Konto: 'Konto Login Passwort Sicherheit Anmeldung Account Bestätigung',
  Arbeit: 'Arbeit Job Projekt Kollegen Aufgabe Meeting',
  Privat: 'Privat Familie Freunde persönlich',
};
